var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 76 76",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M37.6 59.9C49.695 59.9 59.5 50.095 59.5 38C59.5 25.9049 49.695 16.1 37.6 16.1C25.5049 16.1 15.7 25.9049 15.7 38C15.7 50.095 25.5049 59.9 37.6 59.9Z",
          fill: "transparent",
          stroke: "currentColor",
          "stroke-width": "3",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M37.6001 64.2V75.6",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M37.6001 0V11.7",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M0 38H11.4",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.1001 11.4L19.1001 19.4",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.1001 64.6L19.1001 56.5",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M75.1999 38.2H63.8999",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M64.2 11.6L56.2 19.6",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M64.2 64.8L56.2 56.7",
          stroke: "currentColor",
          "stroke-width": "4",
          "stroke-miterlimit": "10"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }